module.exports = __webpack_public_path__ + "static/media/ic_account.5e03edc2.svg";